import dayjs from 'dayjs'

export const fmtDate = (d?: string | null): string =>
  d ? dayjs(d).format('DD-MM-YYYY') : ''
